import React from 'react';
import { formatDateTime } from '../utils/voucherDates';
import { getMovementTypeLabel } from '../utils/voucherMovements';

export default function VoucherHistoryModal({ voucherCode, movements, onClose }) {
  return (
    <div className="fixed inset-0 bg-[rgba(17,24,39,0.24)] backdrop-blur-md z-50 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl bg-[rgba(255,255,255,0.92)] rounded-[32px] shadow-[0_30px_90px_rgba(15,23,42,0.18)] overflow-hidden border border-white/80">
        <div className="flex items-center justify-between px-7 py-5 border-b border-[var(--app-border)]">
          <div>
            <p className="text-[11px] uppercase tracking-[0.24em] text-slate-400">Historial interno</p>
            <h3 className="text-2xl font-semibold text-slate-950">{voucherCode}</h3>
          </div>
          <button onClick={onClose} className="rounded-2xl bg-[rgba(245,245,247,0.9)] hover:bg-white px-4 py-2 font-medium border border-[var(--app-border)]">
            Cerrar
          </button>
        </div>

        <div className="max-h-[70vh] overflow-auto p-6">
          {movements.length === 0 ? (
            <p className="text-slate-500">No hay movimientos registrados.</p>
          ) : (
            <div className="space-y-3">
              {movements.map((movement) => (
                <div key={movement.id} className="border border-[var(--app-border)] rounded-[24px] p-4 bg-white/80">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <div>
                      <p className="font-medium text-slate-900">
                        {getMovementTypeLabel(movement.type)}
                        {movement.type.toLowerCase() !== 'info_update' && ` · ${movement.hours}h`}
                      </p>
                      <p className="text-sm text-slate-500">{formatDateTime(movement.performedAt)}</p>
                    </div>
                    <div className="text-sm text-slate-600">
                      <p>{movement.performedByName || 'Sistema'}</p>
                    </div>
                  </div>
                  {movement.note && <p className="mt-3 text-sm text-slate-600">{movement.note}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
